<template>
  <div>
    <v-layout class="text-xs-right">
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon>
        <v-icon :color="ui.btnColor"> source </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card color="wplgrey0">
          <v-card-title :class="ui.textTitle">
            Attachment
            <v-spacer/>
            {{displayDocumentIDGTypeA(selectedAttachmentItem.basic.tag, selectedAttachmentItem.basic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row>
                <v-chip :color="ui.chipColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                    {{selectedAttachmentItem.basic.idi}}
                  </v-avatar>
                  {{selectedAttachmentItem.basic.title}}
                </v-chip>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs12 sm4>
                  <v-text-field
                    v-model="selectedAttachmentItem.char.theme"
                    prepend-icon="yard"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    v-model="selectedAttachmentItem.char.type"
                    prepend-icon="grid_view"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    v-if="selectedAttachmentItem.char.theme !== 'Comment'"
                    v-model="selectedAttachmentItem.char.ref"
                    prepend-icon="bookmark"
                    readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="ml-2" accesskey=""
              v-if="selectedAttachmentItem.char.theme !== 'Comment'">
                <v-flex xs12>
                  <v-text-field
                    v-model="selectedAttachmentItem.char.link"
                    label="web link / https"
                    prepend-icon="link"
                    readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Attachment Description
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{selectedAttachmentItem.char.com}}
                </div>
              </v-layout>
            </v-container>
            <v-layout row>
              <v-btn @click="closeDialog()" :color="ui.btnColor" flat>
                <v-icon left> exit_to_app </v-icon>
                Close
              </v-btn>
              <v-spacer/>
              <v-btn  target="_blank" :color="ui.btnColor" flat
               :href="this.selectedAttachmentItem.char.link"
               >
                <v-icon left> link </v-icon>
                link
              </v-btn>
            </v-layout>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import master from "@/data/forms/mixins/master.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
export default {
  // eslint-disable-next-lineprog
  mixins: [master, dateFunctions, apptheme, numberFunctions, displayFunctions],
  computed: {
    ...mapGetters(["getAttachmentList", "getCurrentPage"]),
    // selected task item
    selectedAttachmentItem() {
      return this.attachment;
    }
  },
  props: {
    attachment: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      valid: false
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>
